module.exports = __webpack_public_path__ + "static/media/home_servicos1.810b591c.jpg";